import * as TYPES from '../types';
import { REDUX_CONSTANT, VENDOR } from '../../constants';
import { EditIcon, DeactivateIconDisabled } from '../../constants/icon';

const initialState = {
    vendorTypeList: [
        { name: 'All', type: 'item' },
        { name: 'For-Profit', type: 'item' },
        { name: 'Non-Profit', type: 'item' }
    ],
    vendorAPIAccess: ['Integration', 'Production', 'None'],
    marketplaceFlagged: [
        { name: 'All', type: 'item' },
        { name: 'Enabled', type: 'item' },
        { name: 'Disabled', type: 'item' }
    ],
    allowedImageFormat: ['png', 'jpg', 'jpeg'],
    vendorHome3DotsItems: [
        {
            type: 'item',
            name: VENDOR.edit,
            isDisabled: false,
            additionalIcon: { src: EditIcon, alt: 'Edit' }
        },
        {
            type: 'item',
            name: VENDOR.deactivate,
            isDisabled: true,
            additionalIcon: { src: DeactivateIconDisabled, alt: 'Deactivate' }
        }
    ],
    clientSecretIntegrationData: [],
    clientSecretProductionData: [],
    newAddedClientSecretResponse: {}
};

export default function getVendorManagementInformation(
    state = initialState,
    action
) {
    switch (action.type) {
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case REDUX_CONSTANT.ISLOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case REDUX_CONSTANT.GET_VENDOR_MANAGEMENT_DATA:
            return {
                ...state,
                isLoading: false,
                vendorManagementData:
                    action.payload &&
                    action.payload.items &&
                    action.payload.items.length > 0
                        ? action.payload.items
                        : [],
                recordCount: action.payload.recordCount,
                sortOrder: action.payload.sortOrder,
                pageSize: action.payload.pageSize,
                pageNumber: action.payload.pageNumber,
                sortField: action.payload.sortField,
                searchText: action.payload.searchText,
                vendorType: action.payload.vendorType,
                isPublic: action.payload.isPublic,
                vendorTypeList: initialState.vendorTypeList,
                marketplaceFlagged: initialState.marketplaceFlagged
            };
        case REDUX_CONSTANT.GET_ALL_PRODUCTS_DATA:
            return {
                ...state,
                isLoading: false,
                listOfAllProducts: action.payload
            };
        case REDUX_CONSTANT.CREATE_NEW_VENDOR_DATA:
            return {
                ...state,
                isLoading: false,
                createNewVendorData: action.payload
            };
        case REDUX_CONSTANT.GET_CLIENT_SECRET_INTEGRATION_DATA:
            return {
                ...state,
                isLoading: false,
                clientSecretIntegrationData: action.payload?.items ?? []
            };
        case REDUX_CONSTANT.GET_CLIENT_SECRET_PRODUCTION_DATA:
            return {
                ...state,
                isLoading: false,
                clientSecretProductionData: action.payload?.items ?? []
            };

        case REDUX_CONSTANT.ADD_CLIENT_SECRET_INTEGRATION_DATA:
            return {
                ...state,
                isLoading: false,
                newAddedClientSecretResponse: action.payload
            };
        case REDUX_CONSTANT.ADD_CLIENT_SECRET_PRODUCTION_DATA:
            return {
                ...state,
                isLoading: false,
                newAddedClientSecretProductionResponse: action.payload
            };
        case REDUX_CONSTANT.CLEAR_CLIENT_SECRET_RESPONSES:
            return {
                ...state,
                newAddedClientSecretResponse: {},
                newAddedClientSecretProductionResponse: {}
            };
        case REDUX_CONSTANT.DELETE_CLIENT_SECRET_DATA:
            return {
                ...state,
                isLoading: false,
                deleteClientSecretResponse: action.payload
            };
        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };
        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                vendorManagementData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_MANAGEMENT_DATA
                        ? []
                        : state.vendorManagementData,
                vendorUsersData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_USER_LIST_DATA
                        ? []
                        : state.vendorUsersData,
                createNewVendorData:
                    action.payload.title ===
                    REDUX_CONSTANT.CREATE_NEW_VENDOR_DATA
                        ? action.payload.msg
                        : state.createNewVendorData,
                deleteClientSecretResponse:
                    action.payload.title ===
                    REDUX_CONSTANT.DELETE_CLIENT_SECRET_DATA
                        ? action.payload.msg
                        : state.deleteClientSecretResponse,
                clientSecretIntegrationData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_CLIENT_SECRET_INTEGRATION_DATA
                        ? []
                        : state.clientSecretIntegrationData,
                clientSecretProductionData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_CLIENT_SECRET_PRODUCTION_DATA
                        ? []
                        : state.clientSecretProductionData
            };
        default:
            return state;
    }
}
